webpackJsonp([3],{

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(39)(
  /* script */
  __webpack_require__(845),
  /* template */
  __webpack_require__(885),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 845:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PSnackBar',
  props: {
    text: {
      type: String,
      required: true
    },
    show: {
      type: Boolean,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    timeOut: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      top: true
    };
  },

  methods: {
    close: function close() {
      this.$emit('update:show', false);
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val === true && this.timeOut) {
        setTimeout(function () {
          _this.$emit('update:show', false);
        }, this.timeOut);
      }
    }
  }
});

/***/ }),

/***/ 885:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-snackbar', {
    staticClass: "snackbar",
    attrs: {
      "timeOut": _vm.timeOut,
      "top": _vm.top,
      "color": _vm.color
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.text) + "\n"), _c('v-btn', {
    attrs: {
      "color": "white",
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/3.ddbdb3258e4a7fea5e1a.js